module.exports = __webpack_public_path__ + "media/images/logo-10839b9f310dc13081cdb68e77a54d98.png";